import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "mt-5 pl-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "pr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  flat: "",
                  link: "",
                  onClick: _ctx.remove
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-close")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createTextVNode(" " + _toDisplayString(_ctx.uploadFile.datei.name), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { sm: "1" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.uploadFile.getReadableFileSizeString()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { sm: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.uploadFile.dokumentTyp,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadFile.dokumentTyp) = $event)),
                class: "mt-5",
                items: _ctx.typen,
                dense: "",
                "hide-details": ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { sm: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_combobox, {
                ref: "combobox",
                modelValue: _ctx.uploadFile.schlagwortVorschlaege,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploadFile.schlagwortVorschlaege) = $event)),
                search: _ctx.schlagwortSearch,
                "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schlagwortSearch) = $event)),
                items: _ctx.schlagwortSelection,
                label: _ctx.$t('upload.table.schlagworte'),
                "hide-no-data": !_ctx.schlagwortSearch,
                class: "mt-3",
                "append-icon": "",
                multiple: "",
                "bg-color": "white",
                "custom-filter": _ctx.customFilter,
                "clear-on-select": true,
                "hide-selected": true,
                onKeydown: _withKeys(_withModifiers(_ctx.simulateEnter, ["prevent"]), ["space"])
              }, {
                selection: _withCtx(({ attrs, item, selected, index }) => [
                  _createVNode(_component_v_chip, _mergeProps(attrs, {
                    "input-value": selected,
                    label: "",
                    small: "",
                    closable: "",
                    "onClick:close": ($event: any) => (_ctx.deleteSchlagwortFromSelection(index, item.raw))
                  }), {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1040, ["input-value", "onClick:close"])
                ]),
                item: _withCtx(({ props, item, index }) => [
                  (item.raw.header && _ctx.search)
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mr-3" }, "Create", -1)),
                          _createVNode(_component_v_chip, {
                            size: "small",
                            variant: "flat",
                            label: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.search), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (item.raw.header)
                      ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                          key: 1,
                          title: item.title
                        }, null, 8, ["title"]))
                      : (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 2,
                          onClick: props.onClick
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              icon: "mdi-delete",
                              size: "small",
                              variant: "text",
                              onClick: _withModifiers(($event: any) => (_ctx.deleteSchlagwortFromDatabase(index, item.raw)), ["stop","prevent"])
                            }, null, 8, ["onClick"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip, {
                              text: item.raw,
                              variant: "outlined"
                            }, null, 8, ["text"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                ]),
                _: 1
              }, 8, ["modelValue", "search", "items", "label", "hide-no-data", "custom-filter", "onKeydown"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}